import { Grid, Icon } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";

function SinDatos({ titulo, mensaje, icono }) {
  return (
    <Grid container textAlign={"center"} py={3}>
      <Grid item xs={12}>
        <Icon
          sx={{
            width: "50px",
          }}
        >
          {icono || "folder_open"}
        </Icon>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography variant="h6">{titulo || "No hay datos"}</SoftTypography>
      </Grid>
      <Grid item xs={12}>
        <SoftTypography variant="caption" component="p" color="text">
          {mensaje || "No se encontraron datos para mostrar"}
        </SoftTypography>
      </Grid>
    </Grid>
  );
}
export default SinDatos;

SinDatos.propTypes = {
  titulo: PropTypes.string,
  mensaje: PropTypes.string,
  icono: PropTypes.string,
};
